import React from "react";
import { Container, TextField, Card, CardContent, Typography, Box, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import useFetch from "../utils/UseFetch";
import { Buffer } from 'buffer';
import { useNavigate } from "react-router-dom";

const REACT_APP_API_USERNAME = process.env.REACT_APP_API_USERNAME;
const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_UNAME = REACT_APP_API_USERNAME;
const REACT_PWD = REACT_APP_API_PASSWORD;
const REACT_DATA_URL = REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;

const eq = ' eq ';
const filter = '?$filter =';

const MyBidList = () => {
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  const vendorNo = sessionStorage.getItem('vendorNo');
  const navigate = useNavigate();

  // Fetch bids filtered by vendorNo from the API
  const { data: itemsLines, loading, error } = useFetch(
    `${REACT_DATA_URL}bidheader?${REACT_APP_COMPANY_URL}&${filter}vendorNo${eq}'${vendorNo}'`, 
    token
  );

  // console.log(itemsLines);

  // Process the data to create Bids array in reverse order
  const Bids = React.useMemo(() => {
    if (!itemsLines?.value) return [];
    
    return itemsLines.value
      .filter(item => item.vendorNo === vendorNo) // Additional filter to ensure vendorNo matches
      .map(item => ({
        title: item.no,
        description: item.description,
        status:item.Status,
        dueDate: item.validToDate || "N/A",
        postingDate: item.postingDate || "N/A",
        rfpNo: item.rfpNo,
        vendorNo: item.vendorNo,
        buyFromVendorType: item.buyFromVendorType,
      }))
      .reverse(); // Reverse the array to show newest first
  }, [itemsLines, vendorNo]);

  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredBids = Bids.filter(bid =>
    bid.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bid.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleLinkClick = (bid) => {
    navigate(`/applied-for-bid`, { 
      state: { 
        bidNo: bid.title, 
        bidDescription: bid.description, 
        bidStatus:bid.status,
        bidDueDate: bid.dueDate, 
        bidPostingDate: bid.postingDate, 
        from: 'bids',
        rfpNo: bid.rfpNo ,
        buyFromVendorType: bid.buyFromVendorType,
      } 
    });
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, ml: 0 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search bids..."
        sx={{ mb: 3 }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {loading && <Typography>Loading bids...</Typography>}
      {error && <Typography color="error">Error loading bids: {error.message}</Typography>}
      
      {filteredBids.length === 0 && !loading && (
        <Typography>No bids found for your vendor account.</Typography>
      )}

      {filteredBids.map((bid, index) => (
        <Card key={index} sx={{ mb: 2, width: "100%", height: "100px" }}>
          <CardContent>
            <Typography variant="h6" color="primary" sx={{ fontSize: 15 }}>
              <a onClick={() => handleLinkClick(bid)} style={{ cursor: "pointer" }}>
                {bid.title}
              </a>
            </Typography>
            <Typography variant="body1" sx={{ mt: 0 }}>
              {bid.description}
            </Typography>
            <Box sx={{ mt: 1, fontStyle: "italic", color: "gray" }}>
              End Date: {bid.dueDate}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Container>
  );
};

export default MyBidList;